/* eslint-disable no-loop-func */
import {
  Box,
  CircularProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { TableConfigPage } from ".";
import { apiTableGetSchema } from "src/api/endpoints";
import { Autocomplete } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import _ from "lodash"

function TableConfigWrapper({ appConf }) {
  const [schemas, setSchemas] = useState();
  const [tmp, setTmp] = useState();
  const [version, setVersion] = useState({});
  const [schemaObjects, setSchemaObjects] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState(undefined);
  const projectType =
    new URLSearchParams(useLocation().search).get("project_type") ??
    "exome_fastq";
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (
      appConf.schemas[projectType] &&
      schemaObjects.length === appConf.schemas[projectType].length &&
      !id &&
      selectedSchema
    ) {
      let newSchema = selectedSchema;
      // const columns = []
      // for (let i = 0; schemaObjects.length > i; i++) {
      //   const schemaObject = schemaObjects[i];
      //   columns.push(schemaObject.columns)
      // }
      // newSchema.columns = columns.flat();

      // const filteredCols = _.uniqWith(newSchema.columns, _.isEqual);
      // newSchema.columns = filteredCols;
      setSchemas(newSchema);
    }
    if (
      (schemaObjects.length === 1 ||
        appConf.schemas[projectType].length === 1) &&
      !schemas &&
      schemaObjects.length > 0
    ) {
      setSchemas({ ...schemaObjects[0] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schemaObjects, selectedSchema]);

  const schemaHandler = async () => {
    if (appConf.schemas[projectType]) {
      const schemaIds = appConf.schemas[projectType];
      let tmpSchemaObjects = {};
      let allColumns = [];
      for (const schema of schemaIds) {
        await apiTableGetSchema(schema.schema_id, (cols) => {
          tmpSchemaObjects = {
            [cols.version]: cols,
            ...tmpSchemaObjects,
          };
          setVersion({
            version: Number(
              cols.version.replace("v", "").replace("/somatic", "")
            ),
          });
          allColumns.push({ ...cols, label: schema.label });
        });
      }
      if (allColumns.length > 0) {
        setSchemaObjects(() => allColumns);
        setTmp(tmpSchemaObjects);
      }
    }
  };

  useEffect(() => {
    if (!id) {
      schemaHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    (schemaObjects.length === 1 || appConf.schemas[projectType].length === 1) &&
    schemas
  ) {
    return <TableConfigPage tmp={tmp} version={version} schemas={schemas} />;
  }

  return (
    <Box style={{ position: "relative" }}>
      {!schemas && !id && appConf.schemas[projectType].length > 1 && (
        <Box
          className="glass"
          style={{
            position: "fixed",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
            width: "100%",
          }}
        >
          {schemaObjects.length > 0 ? (
            <>
              <Typography>
                {t("Select the desired pipeline type for the filter options")}
              </Typography>
              <Autocomplete
                style={{ width: "60%" }}
                options={schemaObjects}
                onChange={(e, value) => {
                  setSelectedSchema(value);
                }}
                getOptionLabel={(options) => {
                  return options.label
                  // let find = Object.keys(
                  //   appConf.entities.pipeline_classes[projectType]
                  // ).find((key) => {
                  //   if (options.version.includes("/")) {
                  //     if (key.includes(options.version.split("/")[1])) {
                  //       return true;
                  //     } else {
                  //       return false;
                  //     }
                  //   } else {
                  //     return false;
                  //   }
                  // });
                  // if (!find) {
                  //   if (projectType.includes("exome")) {
                  //     if (projectType.includes("fastq"))
                  //       find = ["germline", "nanopore"];
                  //     else if (projectType.includes("bam"))
                  //       find = "germline_bam";
                  //     else if (projectType.includes("vcf"))
                  //       find = "germline_vcf";
                  //   } else if (projectType.includes("acnv")) find = "acnv";
                  //   else if (projectType.includes("acnv_bam"))
                  //     find = "acnv_bam";
                  // }

                  // if (Array.isArray(find)) {
                  //   let tempLabel = "";

                  //   find.forEach((pipeline, index) => {
                  //     if (index >= 1) {
                  //       tempLabel += " / ";
                  //     }
                  //     tempLabel +=
                  //       appConf.entities.pipeline_classes[projectType][
                  //       pipeline
                  //       ];
                  //   });
                  //   return tempLabel;
                  // }
                  // return (
                  //   appConf.entities.pipeline_classes[projectType][find] ?? ""
                  // );
                }}
                renderInput={(props) => (
                  <TextField label={t("Pipeline Type")} {...props} />
                )}
              />
            </>
          ) : (
            <CircularProgress />
          )}
        </Box>
      )}
      {(schemas || id) && (
        <TableConfigPage tmp={tmp} version={version} schemas={schemas} />
      )}
    </Box>
  );
}

const mapStateToProps = (state) => {
  return {
    appConf: state.appConf,
    userObject: state.userObject,
  };
};

export default connect(mapStateToProps)(TableConfigWrapper);
